import { Link } from "react-router-dom";
import { TypographyMuted } from "./ui/typography";
import { ChevronLeft } from "lucide-react";

type Props = {
  text: string;
  to: string;
};

export function BackLink(props: Props) {
  return (
    <TypographyMuted className="ml-1">
      <Link to={props.to} viewTransition>
        <ChevronLeft size={16} className="inline mb-0.5" />
        {props.text}
      </Link>
    </TypographyMuted>
  );
}
